// extracted by mini-css-extract-plugin
module.exports = {"mCard":"zd-z","image":"Ad-z","imageNoBackground":"Bd-z"};